import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import ThemeProvider from 'react-bootstrap/ThemeProvider';
import Header from '../header/Header';
import Sidebar from '../sidebar/Sidebar';
import { fetchWorkspace } from '../../store/ workspace';
import { fetchMailboxes } from '../../store/mailbox';
import { fetchForms, fetchFormsTemplates } from '../../store/forms';
import { fetchLists } from '../../store/lists';
import classes from './Layout.module.css';

const Layout = () => {
    const dispatch = useDispatch();

    const workspace = useSelector(state => state.workspace.workspace);
    const rtl = useSelector(state => state.lc.rtl);

    useEffect(() => {
        dispatch(fetchWorkspace());
        dispatch(fetchMailboxes());
        dispatch(fetchFormsTemplates());
        dispatch(fetchForms());
        dispatch(fetchLists());
        //     dispatch(fetchUsers());
        //     dispatch(fetchUsersAndGroups());
        //     dispatch(fetchDepartments());
        //     dispatch(fetchOrgSideBarItems());
        //     dispatch(fetchLists());
        //     dispatch(fetchWorkflows());
        //     dispatch(fetchFileManagerNodes());
    }, [dispatch])

    useEffect(() => {
        const html = document.getElementsByTagName('html')[0];
        html.dir = rtl ? 'rtl' : '';
        html.lang = rtl ? 'ar' : 'en';
    }, [rtl])

    return (
        <>
            {workspace && workspace._id && (
                <ThemeProvider dir={rtl ? 'rtl' : ''}>
                    <Header />

                    <div className={classes.wrapper}>
                        <Sidebar />
                        <div className={classes.mainContent}>
                            <Outlet />
                        </div>
                    </div>

                    {/* Modals */}
                    {/* <MailboxSideModal />
                <ChatSideModal />
                <AlertsSideModal />
                <CalculatorModal />
                <FSBSettingsModal /> */}

                </ThemeProvider>
            )}
        </>
    );
};

export default Layout;
